<template>
    <div id="cart-modal" v-if="product">
        <div :class="modalClass" tabindex="-1" role="dialog" style="display: block">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="close">
                            <i class="fa fa-times"></i>
                        </button>
                        <h4 class="modal-title">Zum Warenkorb hinzugefügt</h4>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Produkt</th>
                                        <th>Preis</th>
                                        <th>Anzahl</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ product.name }}</td>
                                        <td>{{ product.price }} €</td>
                                        <td>{{ product.qty }}</td>
                                        <td>{{ product.subtotal }} €</td>
                                    </tr>
                                </tbody>
                            </table>
                            <!--img class="img-responsive img-thumbnail" :src="product.image">-->
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a :href="url" class="btn btn-info">Zum Warenkorb!</a>
                        <button type="button" class="btn btn-default" @click="close">OK</button>
                    </div>
                </div>
            </div>
        </div>
        <div :class="backdropClass"></div>
    </div>
</template>

<script>
export default {

  data() {
    return {
        product: null
    }
  },

  created() {

      App.event.listen('cart.item.inserted', (product) => {
          product.subtotal = parseFloat(product.subtotal) + (parseFloat(product.tax) * parseInt(product.qty));
          product.subtotal = product.subtotal.toFixed(2).replace(".", ",");
          product.price = parseFloat(product.price) + parseFloat(product.tax);
          product.price = product.price.toFixed(2).replace(".", ",");
          product.tax = parseFloat(product.tax).toFixed(2).replace(".", ",");
          this.product = product;
      });

  },

  methods: {
      close() {
          this.product = null;
      }
  },

  computed: {
      url() {
          return App.url + '/cart';
      },

      modalClass() {
          return this.product ? 'modal fade in' : 'modal fade';
      },

      backdropClass() {
          return this.product ? 'modal-backdrop fade in' : 'modal-backdrop fade';
      }
  }

}
</script>
